import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CRM_PROPOSAL_PATHS, ProposalPathsProvider } from '@/lib/proposals/proposal-paths';

/**
 * `/crm/proposals/*` mounts the SAME proposal pages as `/proposals/*`, with CRM paths, so the CRM
 * shows proposals while it is built (ENT-565). When the CRM is fully wired, `/proposals/*` is deleted.
 */
export const Route = createFileRoute('/crm/proposals')({
  component: CrmProposalsLayout,
});

function CrmProposalsLayout() {
  return (
    <ProposalPathsProvider paths={CRM_PROPOSAL_PATHS}>
      <Outlet />
    </ProposalPathsProvider>
  );
}
